export const organizations = 'organizations';
export const organization = 'organization';
export const orgMembers = 'organization_members';
export const orgCancellationOptions = 'organization_cancellation_options';
export const orgMember = 'organization_member';
export const orgMemberRtmElection = 'organization_member_rtm_election';
export const orgCancellationDetails = 'organization_cancellation_details';
